import { FC, forwardRef } from "react";
import { Dropdown } from "react-bootstrap";
import { Action } from "../types";
import OverlayTrigger, {
  OverlayInjectedProps,
} from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";

type DottedMenuProps = { id: string; actions: Action[] };
type PopoverPros = OverlayInjectedProps & { message: string };

const labelToIconClass = {
  Anteprima: "bi bi-eye",
  Sposta: "bi-arrows-move",
  Elimina: "bi-trash3",
  Rinomina: "bi-pencil-square",
};

const ActionPopover = forwardRef<HTMLInputElement, PopoverPros>(
  ({ message, ...rest }, ref) => (
    <Popover id="popover-basic" {...rest} ref={ref}>
      <Popover.Body>{message}</Popover.Body>
    </Popover>
  )
);

export const DottedMenu: FC<DottedMenuProps> = ({ id, actions }) => {
  return (
    <Dropdown>
      <Dropdown.Toggle
        id={id}
        role="menuitem"
        style={{ borderColor: "transparent", backgroundColor: "transparent" }}
      >
        <i className="bi bi-three-dots-vertical"></i>
      </Dropdown.Toggle>
      <Dropdown.Menu flip={false} align="end">
        {actions.map(({ action, label, tooltipDisabledMessage }, i) =>
          tooltipDisabledMessage ? (
            <OverlayTrigger
              key={i}
              trigger={["hover", "focus"]}
              placement="top"
              overlay={(props) => (
                <ActionPopover {...props} message={tooltipDisabledMessage} />
              )}
            >
              <Dropdown.Item
                className="text-light cursor-notAllowed"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
              >
                <i className={`bi me-2 ${labelToIconClass[label]}`}></i>
                {label}
              </Dropdown.Item>
            </OverlayTrigger>
          ) : (
            <Dropdown.Item key={i} onClick={action} className="text-dark">
              <i className={`bi me-2 ${labelToIconClass[label]}`}></i>
              {label}
            </Dropdown.Item>
          )
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
};
